import Axios from "axios";
import React, { Component } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    NavLink,
    useParams,
    useRouteMatch,
    useHistory,
    Redirect,
} from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import hoistStatics from "hoist-non-react-statics";
import { toPng } from "html-to-image";
import Func from "../../functions";
import Loading from "../../layouts/Loading";
import Env from "../../env";
import Text from "../pages/cashier/Text";
import OrderDetail from "../pages/cashier/OrderDetailList";
import Button from "../pages/cashier/Button";
import { QRCode } from "react-qrcode-logo";

class GCashQR extends Component {
    constructor(props) {
        super(props);
      
        this.state = {
            layout: "emu",
            step: "phone_number",
            imageContent: "",
            qrCodeId: Date.now().toString(),
        };
    }

    componentDidMount = async () => {
        $(document).prop("title", "GCash Payment Information");
        $("#favicon").attr("href", "/images/gcash/base_icon.png");

        let isPhone = false;
        if (this.isIphone() || this.isAndroid()) {
            isPhone = true;
        }

        this.resizeLogo(); 
        window.addEventListener("resize", this.resizeLogo);
        window.addEventListener("load", this.resizeLogo);
        this.props.i18n.changeLanguage(this.props.lngName);
    };

    componentWillUnmount = async () => {
        $(document).prop("title", "GCash");

        window.removeEventListener("resize", this.resizeLogo);
        window.removeEventListener("load", this.resizeLogo);
    };

    setLoading = (v) => {
        this.setState({ isLoading: v });
    };

    showPayerInfo = () => {
        return this.props.payerName.substr(1);
    };

    showAmount = () => {
        return parseFloat(this.props.data.amount)
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    };

    openGCashApp = () => {
        if (this.props.data.detail.hasOwnProperty("extend")) {
            setTimeout(() => {
                window.location = this.props.data.detail.extend;
            }, 888);
        }
    };

    isIphone = () => {
        let nua = navigator.userAgent;

        if (nua.includes("iPhone")) {
            return true;
        }

        return false;
    };

    isAndroid = () => {
        let nua = navigator.userAgent;

        if (nua.includes("Android")) {
            return true;
        }

        return false;
    };

    resizeLogo = () => {
      const logo = document.getElementById("header-logo");
      if (!logo) return;
  
      const isPhone = this.isIphone() || this.isAndroid();
  
      if (isPhone) {
          logo.style.maxWidth = "150px"; // 手機版
      } else {
          logo.style.maxWidth = "300px"; // 桌機版
      }
    };
  

    render() {

      let qrWidth = this.props.qrWidth || 60;
      const color = this.props.color || "rgb(0, 87, 228)";
      const showDetail = this.props.showDetail || false;
      const isPhone = this.isIphone() || this.isAndroid();

      if (isPhone) {
          qrWidth = 68;
      }

      const qrCodeSize = $("#pageMain").width() * (qrWidth / 100);

      const styles = {
          wrapper: {
              height: "100%",
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
          },
          contentWrapper: {
              height: "100%",
              position: "relative",
              overflow: "hidden",
              marginLeft: "0px"
          },
          contentWrapperBackground: {
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "25%",
              background: color, // 動態設定背景顏色
          },
          qrCodeImgDiv: {
              display: "inline-block",
              margin: "0 auto",
              border: "1px solid"
          },
          qrCodeImg: {
              width: qrCodeSize+"px",
              height: qrCodeSize+"px",
              objectFit: "contain"
          }
      };

        return (
            <div className="hold-transition sidebar-mini layout-top-nav">
            <div className="wrapper" style={styles.wrapper}>
              <div className="content-wrapper" style={styles.contentWrapper}>
              <div style={styles.contentWrapperBackground}></div>
                <div className="content-header">
                  <div className="container-fluid">
                    <div className="row mb-2">
                      <div className="col-sm-12 text-center">
                        <img
                          id="header-logo"
                          className="header-logo"
                          src="/images/gcash_header_logo.png"
                          alt="GCash Logo"
                        />
                      </div>
                    </div>
                  </div>
                </div>
      
                <div className="content">
                  <div className="container">
                    <div className="row justify-content-center">
                      <div className="col-md-6">
                        <div id="pageMain" className="card shadow-sm">
                          <div className="card-body text-center">
                             {showDetail && (
                                <OrderDetail
                                    details={[
                                        { label: "Unique No", value: this.props.data.cashierNo },
                                        { label: "Amount Due", value: this.showAmount() },
                                    ]}
                                />
                            )}

                            <Text
                                text={'Securely complete the payment with your GCash app'}
                                color=''
                            />
                            <Button
                                    text={'Open in GCash'}
                                    callback={() => this.openGCashApp()}
                                    color={color}
                            />

                            <Text
                                text={'or Log in to GCash and scan this QR with the QR Scanner.'}
                            />
                            {
                              this.props.data.detail.qrcode.startsWith("http://") ||
                              this.props.data.detail.qrcode.startsWith("https://") ? (
                                <div style={styles.qrCodeImgDiv}>
                                  <img
                                    id={"img_" + this.state.qrCodeId}
                                    src={this.props.data.detail.qrcode}
                                    style={styles.qrCodeImg}
                                    alt="QR Code"
                                  />
                                </div>
                              ) : (
                                  <div style={styles.qrCodeImgDiv}>
                                  <QRCode
                                    id={"qr_" + this.state.qrCodeId + "_code"}
                                    value={this.props.data.detail.qrcode}
                                    ecLevel="M"
                                    size={qrCodeSize} // 控制 QR code 本身大小
                                  />
                                </div>
                              )
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
    }
}

export default hoistStatics(withTranslation()(GCashQR), GCashQR);
